{
  "it": {
    "datatable": {
      "actions": {
        "bulk_action": "Azione collettiva",
        "bulk_edit": "Modifica collettiva",
        "clear": "Svuota",
        "clear_filters": "Svuota filtri",
        "collapse_all": "Comprimi tutto",
        "deselect_all": "Deseleziona tutto",
        "expand_all": "Espandi tutto",
        "select_all": "Seleziona tutto"
      },
      "import": {
        "error_row": "Riga {row}",
        "errors_description": "L'importazione è stata annullata perché {count} riga/righe contenevano errori. Nessun record è stato importato.",
        "errors_title": "Importazione non riuscita",
        "success": "File importato correttamente",
        "title": "Importa"
      },
      "labels": {
        "columns_selected": "{count} colonne selezionate",
        "freeze_columns": "Blocca colonne",
        "freeze_rows": "Blocca righe",
        "gridlines": "Linee della griglia",
        "group_by": "Raggruppa per",
        "size": "Dimensione",
        "sticky_headers": "Intestazioni fisse",
        "striped_rows": "Righe alternate",
        "toggle_columns": "Attiva/disattiva colonne",
        "translation_style": "Stile di traduzione",
        "translation_mode_toolbar": "Globale",
        "translation_mode_header": "Intestazione",
        "translation_mode_stacked": "Impilato"
      }
    }
  }
}
